import { AuthState } from './types'

export const INITIAL_STATE = (): AuthState => ({
  user: null
})
